import { useMagicLinkTokens } from "@features/auth/hooks/useMagicLinkTokens";
import { useOnboardingGate } from "@features/onboardings/hooks/useOnboardingGate";
import { useOnboardingStore } from "@features/onboardings/hooks/useOnboardingStore";

/**
 * Shared destination for every post-authentication entry point.
 * Priority is redeem > onboarding > home.
 */
export const usePostAuthRedirectPath = () => {
	const { redeemCode, authMode } = useMagicLinkTokens();
	const legacyShowOnboarding = useOnboardingStore(
		(state) => state.showOnboarding,
	);
	const { isLoading, hasOnboardingFlow, needsOnboarding } = useOnboardingGate();

	// A new account cannot already satisfy requiredFields, so the signup signal
	// never contradicts the gate.
	const showOnboarding =
		needsOnboarding ||
		(hasOnboardingFlow && (legacyShowOnboarding || authMode === "signup"));

	return {
		isLoading,
		postAuthRedirectPath: redeemCode
			? (`/redeem?redeemCode=${redeemCode}` as const)
			: showOnboarding
				? ("/onboarding" as const)
				: ("/home" as const),
	};
};
